import * as actionTypes from "../actionTypes";

const initialState = {
  error: null,
  isLoader: false,
  strengths:[],
};

const strengthsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_STRENGTHS:
      const data =[]
      return {
        isLoader:true,
        strengths:data
      };
    case actionTypes.GET_STRENGTHS_SUCCESS:
      return {
        isLoader:false,
        strengths: payload,
      };
    case actionTypes.GET_STRENGTHS_ERROR:
      return {
        ...state,
        isLoader:false
      };

    default:
      return state;
  }
};
export default strengthsReducer
